module.exports = __webpack_public_path__ + "img/KSC01176.9eba400f.jpg";